import { useState } from 'react';
import { HeadingsConfig, ResponsiveHeadings, TextSettings, ThemeConfig } from '../../../../types/theme';
import Accordion from '../../../../components/ui/Accordion';
import { useTheme } from '../../../../contexts/ThemeContext';

interface FontSettingsState {
  h1: { fontSize: string; fontWeight: string; lineHeight: string };
  h2: { fontSize: string; fontWeight: string; lineHeight: string };
  h3: { fontSize: string; fontWeight: string; lineHeight: string };
  h4: { fontSize: string; fontWeight: string; lineHeight: string };
  h5: { fontSize: string; fontWeight: string; lineHeight: string };
  h6: { fontSize: string; fontWeight: string; lineHeight: string };
  small: { fontSize: string; fontWeight: string; lineHeight: string };
}

interface TypographySettings {
  fontFamily: string;
  headings: ResponsiveHeadings;
  menuFont: {
    desktop: TextSettings;
    tablet: TextSettings;
    mobile: TextSettings;
    fontFamily: string;
  };
  paragraph: {
    desktop: TextSettings;
    tablet: TextSettings;
    mobile: TextSettings;
  };
}

export default function FontSettings() {
  const { activeTheme, updateTheme } = useTheme();

  const defaultTypographySettings = {
    typography: {
      fontFamily: '',
      headings: {
        desktop: {
          h1: { fontSize: '', lineHeight: '', fontWeight: '', letterSpacing: '' },
          h2: { fontSize: '', lineHeight: '', fontWeight: '', letterSpacing: '' },
          h3: { fontSize: '', lineHeight: '', fontWeight: '', letterSpacing: '' },
          h4: { fontSize: '', lineHeight: '', fontWeight: '', letterSpacing: '' },
          h5: { fontSize: '', lineHeight: '', fontWeight: '', letterSpacing: '' },
          h6: { fontSize: '', lineHeight: '', fontWeight: '', letterSpacing: '' }
        },
        tablet: {
          h1: { fontSize: '', lineHeight: '', fontWeight: '', letterSpacing: '' },
          h2: { fontSize: '', lineHeight: '', fontWeight: '', letterSpacing: '' },
          h3: { fontSize: '', lineHeight: '', fontWeight: '', letterSpacing: '' },
          h4: { fontSize: '', lineHeight: '', fontWeight: '', letterSpacing: '' },
          h5: { fontSize: '', lineHeight: '', fontWeight: '', letterSpacing: '' },
          h6: { fontSize: '', lineHeight: '', fontWeight: '', letterSpacing: '' }
        },
        mobile: {
          h1: { fontSize: '', lineHeight: '', fontWeight: '', letterSpacing: '' },
          h2: { fontSize: '', lineHeight: '', fontWeight: '', letterSpacing: '' },
          h3: { fontSize: '', lineHeight: '', fontWeight: '', letterSpacing: '' },
          h4: { fontSize: '', lineHeight: '', fontWeight: '', letterSpacing: '' },
          h5: { fontSize: '', lineHeight: '', fontWeight: '', letterSpacing: '' },
          h6: { fontSize: '', lineHeight: '', fontWeight: '', letterSpacing: '' }
        }
      },
      menuFont: {
        desktop: { fontSize: '', lineHeight: '' },
        tablet: { fontSize: '', lineHeight: '' },
        mobile: { fontSize: '', lineHeight: '' },
        fontWeight: 400,
        boldWeight: 700,
        letterSpacing: '',
        textTransform: 'none',
        fontStyle: 'normal',
        fontFamily: ''
      },
      paragraph: {
        desktop: { fontSize: '', lineHeight: '' },
        tablet: { fontSize: '', lineHeight: '' },
        mobile: { fontSize: '', lineHeight: '' },
        fontWeight: 400,
        boldWeight: 700,
        letterSpacing: '',
        textTransform: 'none',
        fontStyle: 'normal'
      }
    },
    colors: { primary: '', secondary: '' },
    layout: { containerWidth: '', spacing: '' },
    buttons: { borderRadius: '', padding: '' },
    customCSS: ''
  };

  const updateThemeSettings = (
    section: keyof TypographySettings,
    device: keyof ResponsiveHeadings,
    element: string,
    value: string
  ) => {
    if (!activeTheme) return;

    const newTheme: ThemeConfig = {
      ...activeTheme,
      settings: {
        ...activeTheme.settings || defaultTypographySettings,
        typography: {
          ...(activeTheme.settings?.typography || defaultTypographySettings.typography)
        }
      }
    };

    if (section === 'headings') {
      newTheme.settings.typography.headings = {
        ...newTheme.settings.typography.headings,
        [device]: {
          ...newTheme.settings.typography.headings[device],
          [element]: {
            ...newTheme.settings.typography.headings[device][element as keyof HeadingsConfig],
            fontSize: element === 'fontSize' ? value : newTheme.settings.typography.headings[device][element as keyof HeadingsConfig].fontSize,
            lineHeight: element === 'lineHeight' ? value : newTheme.settings.typography.headings[device][element as keyof HeadingsConfig].lineHeight,
            fontWeight: element === 'fontWeight' ? value : newTheme.settings.typography.headings[device][element as keyof HeadingsConfig].fontWeight
          }
        }
      };
    }
    else {
      const typographySection = newTheme.settings.typography[section];
      if (typographySection && typeof typographySection === 'object' && 'desktop' in typographySection) {
        if (device in typographySection) {
          (typographySection[device] as any) = {
            ...(typographySection[device] as any),
            [element]: value
          };
        }
      }
    }

    updateTheme(newTheme);
  };

  return (
    <div>
      <Accordion
        title="Impostazioni Font"
        defaultOpen={true}
      >
        <div className="space-y-4">
          {/* ... resto del JSX ... */}
        </div>
      </Accordion>
    </div>
  );
} 